import { Component, Input, OnInit, EventEmitter, Output }  from '@angular/core';
import { FormGroup }                 from '@angular/forms';
import { PreguntaBase }              from '../_models/preguntabase.model';
import { PreguntasControlService }    from '../_services/preguntascontrol.service';

import { DropdownPregunta } from '../_models/preguntabase-dropdown.model';

@Component({

  selector: 'dynamic-form',
  templateUrl: './formulario.template.html',
  providers: [ PreguntasControlService ]

})
export class FormularioComponent implements OnInit {

  @Input() questions: PreguntaBase<any>[] = [];
  @Output() onVoted = new EventEmitter<boolean>();

  form: FormGroup;
  payLoad = '';
  descripcion: any;

  constructor(private qcs: PreguntasControlService) {  }

  ngOnInit() {
    this.form = this.qcs.toFormGroup(this.questions);

    //console.log(this.questions);

  }

  onSubmit() {
    this.payLoad = JSON.stringify(this.form.value);
  }

  actualizarPregunta(){

    this.onVoted.emit(true);



  }
}



// WEBPACK FOOTER //
// ./src/app/formulario/formulario.component.ts